import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./screen-reader-only.css.ts.vanilla.css-mistica.js";
var y = "gwdgwo1 _1y2v1nf71 _1y2v1nf8a _1y2v1nf9j _1y2v1nfas _1y2v1nfh3 _1y2v1nfk9 _1y2v1nfjq";
export { y as screenReaderOnly };
